import React from 'react';
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { forwardRef } from '../forward-ref';
import { Minus } from '../../icons/minus';
import { Check } from '../../icons/check';
export const Checkbox = forwardRef((props, ref)=>{
    const { children , ...checkboxProps } = props;
    const withIcon = checkboxProps.isChecked || checkboxProps.isIndeterminate;
    const Icon = checkboxProps.isIndeterminate ? Minus : Check;
    return /*#__PURE__*/ React.createElement(ChakraCheckbox, {
        ref: ref,
        ...checkboxProps,
        ...withIcon ? {
            icon: /*#__PURE__*/ React.createElement(Icon, {
                strokeWidth: "3px"
            })
        } : {}
    }, children);
});

//# sourceMappingURL=checkbox.js.map